import { useQuery } from '@tanstack/react-query'
import { filterElement } from '~/features/BookingCars/ListBookingCars/config'
import { Region } from '~/shared/api'
import { SelectMultiple } from '~/shared/ui/ScrollableList'

const { location } = filterElement

type LocationsProps = {
  regionCode?: UniqueId
  onChange: () => void
}

export function Locations({ regionCode, onChange }: LocationsProps) {
  const handleLocationsGet = async () => {
    if (!regionCode) return []

    const response = await Region.with('locations')
      .where('regionCode', regionCode)
      .first()

    return response
      ?.getData()
      ?.getLocations()
      .map((location) => location?.getOption())
  }

  const { isFetching, data = [] } = useQuery(
    ['async-location-options', regionCode],
    () => handleLocationsGet(),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )

  return (
    <SelectMultiple
      isLoading={isFetching}
      options={data}
      onChange={onChange}
      {...(!regionCode
        ? { empty: 'Для фильтрации по локациям выберите регион' }
        : {})}
      {...location}
    />
  )
}
